// Deep-links del portal del vendedor (`?customer=`, `?prospect=`, `?sale=`, `?sku=`, `?tab=prospects`).

/** Pestañas de Clientes; la de clientes es la de entrada y no viaja en la URL. */
export type CustomersSectionTab = 'customers' | 'prospects';

export interface SalesSectionSearch {
    /** Pestaña de Clientes: solo `prospects` se lee; cualquier otro valor cae en clientes. */
    tab?: 'prospects';
    /** `retailCustomerId` de la ficha a abrir en Clientes. */
    customer?: string;
    /** `prospectId` de la fila a abrir en Prospectos. */
    prospect?: string;
    /** `saleId` de la venta a abrir en Mis ventas. */
    sale?: string;
    /** SKU del equipo a abrir en Catálogo. */
    sku?: string;
}

/**
 * Lee el query string SIN lanzar nunca: una URL vieja o manipulada tiene que caer al estado normal
 * de la pantalla, no romper la ruta entera.
 */
export function parseSalesSectionSearch(search: Record<string, unknown>): SalesSectionSearch {
    const prospect = idOf(search.prospect);
    // Un `?prospect=` sin pestaña solo tiene sentido en Prospectos.
    const tab = search.tab === 'prospects' || prospect !== undefined ? 'prospects' : undefined;
    return {
        tab,
        customer: idOf(search.customer),
        prospect,
        sale: idOf(search.sale),
        sku: idOf(search.sku),
    };
}

/** Un id útil es texto no vacío; cualquier otra cosa se descarta. */
function idOf(value: unknown): string | undefined {
    if (typeof value !== 'string') return undefined;
    const trimmed = value.trim();
    return trimmed === '' ? undefined : trimmed;
}

/**
 * Prospectos vive como pestaña de Clientes: la sección vieja `prospects` manda ahí conservando
 * `?prospect=`. `null` para cualquier otra sección.
 */
export function legacySectionRedirect(
    section: string,
    search: SalesSectionSearch,
): { section: string; search: SalesSectionSearch } | null {
    if (section !== 'prospects') return null;
    return {
        section: 'customers',
        search: search.prospect
            ? { tab: 'prospects', prospect: search.prospect }
            : { tab: 'prospects' },
    };
}
